import api from './axiosConfig';

export interface BigQueryHandoffSetting {
  id: number;
  is_enabled: boolean;
  project_id: string | null;
  location: string;
  raw_dataset: string;
  staging_dataset: string;
  mart_dataset: string;
  semantic_dataset: string;
  export_directory: string;
  has_service_account_json: boolean;
  last_exported_at: string | null;
  last_export_status: string | null;
  last_export_message: string | null;
  last_export_manifest: BigQueryExportManifest | null;
}

export interface BigQueryExportFile {
  path: string;
  rows: number;
}

export interface BigQueryExportManifest {
  date: string;
  disk: string;
  base_path: string;
  files: Record<string, BigQueryExportFile>;
}

export interface BigQueryHandoffContract {
  datasets: string[];
  files: Record<string, string>;
  required_rules: string[];
}

export interface BigQueryHandoffPayload {
  is_enabled: boolean;
  project_id: string | null;
  location: string;
  raw_dataset: string;
  staging_dataset: string;
  mart_dataset: string;
  semantic_dataset: string;
  export_directory: string;
  service_account_json?: string;
  clear_service_account_json?: boolean;
}

export interface BigQueryHandoffResponse {
  success: boolean;
  data: {
    setting: BigQueryHandoffSetting;
    contract: BigQueryHandoffContract;
  };
}

export interface BigQueryExportResponse {
  success: boolean;
  data: {
    setting: BigQueryHandoffSetting;
    manifest: BigQueryExportManifest;
  };
}

const adminBigQueryHandoffService = {
  async get(): Promise<BigQueryHandoffResponse> {
    const response = await api.get<BigQueryHandoffResponse>('/admin/bigquery-handoff');
    return response.data;
  },

  async update(payload: BigQueryHandoffPayload): Promise<{ success: boolean; data: { setting: BigQueryHandoffSetting } }> {
    const response = await api.put('/admin/bigquery-handoff', payload);
    return response.data;
  },

  async export(date?: string): Promise<BigQueryExportResponse> {
    const response = await api.post<BigQueryExportResponse>('/admin/bigquery-handoff/export', {
      date,
      mode: 'handoff_files',
    });
    return response.data;
  },
};

export default adminBigQueryHandoffService;
